<template>
  <aside class="menu" :class="[expanded ? '' : 'menu-close', mobileOpen ? 'mobile-open': 'mobile-close', isGuest ? 'navbar-guest' : 'navbar-user']" >
    <div class="navbar-wpr">
      <router-link class="navbar-item brand" to="/">
        <hv-image :src="logoUrl" alt="HireVibes" size="is-60x60"
          :is-rounded="false" />
      </router-link>
      <a role="button" class="navbar-burger" @click="toggleMenu" aria-label="menu" aria-expanded="false" :class="mobileOpen ? 'is-active': ''">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div class="menu-items p-t-24 menu-item-start">

        <router-link v-for="(link) in menuItems.common" :key="link.title" v-if="link.to !== '/about'"  class="navbar-item"
                     :class="{'is-active': isActive(link) }" :to="link.to"
                     >
          <i  class="menu-item-icon" :class="link.icon"></i>
          <label>{{ link.title }}</label>
        </router-link>
        <a class="navbar-item no-color" href="https://www.hirevibes.io/" target="_blank" v-else>
          <i  class="menu-item-icon" :class="link.icon"></i>
          <label>{{ link.title }}</label>
        </a>
    </div>
    <div class="menu-items menu-item-end">
      <div @click="moveToJobs" v-if="isHirer"   class="navbar-item create-btn"
                    >
        <img :src="require('../../assets/plus.svg')" width="20px" height="20px" alt="">
        <p class="navitem-help-text" ></p>
        <label>Create Job</label>
      </div>
      <router-link v-for="(link) in menuItems.admins" class="navbar-item"
        :class="{'is-active': isActive(link), 'has-help-text': checkHelpText(link) }" :to="link.to"
        :key="link.title">
        <i v-if="link.icon" class="menu-item-icon" :class="link.icon"></i>
        <p class="navitem-help-text" v-if="link.helpText">{{link.helpText}}</p>
        <label>{{ link.title }}</label>
      </router-link>
      <divider class="navbar-divider" v-if="(menuItems.users && menuItems.admins )&& (menuItems.users.length > 0 && menuItems.admins.length > 0)"></divider>
      <router-link v-for="(link) in menuItems.users" class="navbar-item"
        :class="{'is-active': isActive(link) }" :to="link.to"
        :key="link.title">
        <i v-if="link.icon" class="menu-item-icon" :class="link.icon"></i>
        <label>{{ link.title }}</label>
      </router-link>
      <user-item v-if="loggedIn" />
    </div>
    <div class="menu-items p-b-24">
<!--      <flag-dropdown v-if="!user" :isDropdown="true" />-->
      <a class="navbar-item navbar-expender" @click="toggleExpend">
        <i  class="menu-item-icon" :class="expanded ? 'icon-close' : 'icon-expand'"></i>
      </a>
    </div>
  </aside>
</template>
<script>
import HvImage from '@/components/general/image'
import HvLogo from '@/assets/hv-logo.svg'
import NavbarItems from '@/components/navbar/navbar-items'
import Divider from '@/components/general/divider'
import UserItem from '@/components/navbar/user-items'
import FlagDropdown from '@/components/navbar/flag-items'
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'
import numeral from 'numeral'

export default {
  components: {HvImage, NavbarItems, Divider, FlagDropdown, UserItem},
  data () {
    return {
      mobileOpen: false
    }
  },
  props: {
    expanded: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('jobs', ['jobCategory', 'ecoSystem']),
    ...mapState('loading', ['loading', 'loadingPercentage']),
    ...mapState('users', ['user', 'intercomUser']),
    ...mapGetters('users', ['profilePictureUrl']),
    ...mapState('statuses', {messageCount: 'messages'}),
    ...mapGetters('wallet', ['getActiveTokenBalance', 'getActiveToken']),
    enableIntercom () {
      return !window.location.pathname.includes('/widget') ? !this.$route.meta.disableIntercom : false
    },
    expandLabel () {
      return this.expanded ? 'Close' : 'Expand'
    },
    logoUrl () {
      return HvLogo
    },
    authType () {
      return this.$route.meta.authType
    },
    loggedIn () {
      return this.authType !== 'unauth'
    },
    isSignupPage () {
      return this.$route.fullPath === '/signup'
    },
    isLoginPage () {
      return this.$route.fullPath === '/login'
    },
    isGuest () {
      if (!this.user) {
        return true
      }
      return false
    },
    isHirer () {
      if (this.user) {
        return this.user.profile === 'hirer'
      }
      return false
    },
    menuItems () {
      const msgPost = this.messageCount > 0 ? `(${this.messageCount})` : ''
      const links = {'users': [], 'admins': [], 'common': []}
      if (!this.user) {
        links.common = [{
          title: this.$t('nav.jobs'),
          to: `/jobs/${this.ecoSystem}/${this.jobCategory}`,
          icon: 'icon-job'
        }, {
          title: this.$t('nav.companies'),
          to: '/companies',
          icon: 'icon-companies'
        }, {
          title: this.$t('nav.about'),
          to: '/about',
          icon: 'icon-about'
        }
        //   {
        //   title: this.$t('community.vibesDao'),
        //   to: '/dao-community',
        //   icon: 'icon-dao'
        // }
        ]
        if (this.isSignupPage) {
          links.admins = [{
            title: this.$t('nav.login'),
            to: '/login',
            helpText: this.$t('nav.have-an-account')
          }]
        } else if (this.isLoginPage) {
          links.admins = [{
            title: this.$t('nav.signup'),
            to: '/signup',
            helpText: this.$t('nav.dont-have-an-account')
          }]
        } else {
          links.admins = [{
            title: this.$t('nav.login'),
            to: '/login',
            helpText: this.$t('nav.have-an-account')
          }, {
            title: this.$t('nav.signup'),
            to: '/signup',
            helpText: this.$t('nav.dont-have-an-account')
          }]
        }
        return links
      }
      if (this.loggedIn && this.user) {
        links.common = [{
          title: this.$t('nav.jobs'),
          to: `/jobs/${this.ecoSystem}/${this.jobCategory}`,
          icon: 'icon-job'
        },
        {
          title: this.$t('nav.companies'),
          to: '/companies',
          icon: 'icon-companies'
        }, {
          title: this.$t('nav.jobseekers'),
          to: '/jobseekers',
          icon: 'icon-jobseekers'
        }, {
          title: `${this.$t('nav.messages')} ${msgPost}`,
          to: '/messages',
          icon: 'icon-messages'
        }
        //   {
        //   title: this.$t('community.vibesDao'),
        //   to: '/dao-community',
        //   icon: 'icon-dao'
        // }

        ]

        if (this.user.profile !== 'hirer') {
          links.common = [ ...links.common,
            {
              title: this.$t('nav.referrals'),
              to: '/referrals',
              icon: 'icon-referrals'
            }]
        }

        if (this.user && (this.user.isAdmin || this.user.profile === 'hirer' || this.user.profile === 'jobboardowner')) {
          links.admins = [{
            title: this.$t('nav.my-jobs'),
            to: '/admin/jobs',
            icon: 'icon-admin-my-jobs'
          },
          {
            title: this.$t('nav.applicants'),
            to: '/admin/applications',
            icon: 'icon-admin-applicants'
          }]
        }

        if (this.user) {
          links.users.push({
            title: `VIBES ${numeral(this.balance).format('0.00a')}`,
            to: '/wallet',
            icon: 'icon-wallet'
          })
        }

        return links
      }
      return []
    },
    balance () {
      return this.getActiveTokenBalance ? this.getActiveTokenBalance.balance : 0
    }
  },
  methods: {
    ...mapActions('users', [
      'getUser',
      'getCurrentUserInfo'
    ]),
    ...mapMutations('jobs', ['setCreateJobTrigger']),
    toggleExpend () {
      this.$emit('toggle-expend')
    },
    moveToJobs () {
      this.$router.push('/admin/jobs/createJob')
      this.setCreateJobTrigger()
    },
    isActive ({ to }) {
      const active = this.$route.fullPath === to
      if (active) { return true }
      if (this.$route.fullPath === '/' && to === '/jobs') {
        return true
      }
      return this.$route.fullPath.includes(`${to}/`)
    },
    checkHelpText (link) {
      return link.helpText !== undefined
    },
    toggleMenu () {
      this.mobileOpen = !this.mobileOpen
    }
  },
  mounted () {
    if (this.loggedIn) {
      this.getCurrentUserInfo()
      this.getUser()
    }
    if (this.enableIntercom) {
      this.$intercom.boot({ name: 'Guest' })
    }
    document.documentElement.classList.add('has-navbar-fixed-top')
  },
  watch: {
    authType: function (oldType, newType) {
      if (this.loggedIn) {
        this.getUser()
        this.getCurrentUserInfo()
      }
    },
    $route: function (r) {
      this.mobileOpen = false
    },
    intercomUser: {
      deep: true,
      handler: function (u) {
        if (u) {
          this.$intercom.update({ user_id: u.id, name: `${u.firstName} ${u.lastName}`, email: u.email, custom_launcher_selector: '.open_intercom' })
        } else {
          this.$intercom.update({ user_id: null, name: 'Guest', custom_launcher_selector: '.open_intercom' })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '~@/styles/defaults.scss';
  aside {
    position: fixed;
    height: 100vh;
    background: #fff;
    top: 0;
    bottom: 0;
    border-right: 1px solid #ddd;
    min-width: $sidebar-width;
    width: $sidebar-width;
    padding-left: 8px;
    padding-right: 8px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    z-index: 1;
  }
  .menu-item-start {
    flex-grow: 2
  }

  .mobile-close {
    padding-top: 24px;
  }

  .navbar-divider {
    margin:8px;
  }

  .menu-close {
    width: $sidebar-width-close;
    min-width: $sidebar-width-close;
    padding-left: 0;
    padding-right: 0;
    .navbar-item {
      label {
        display: none;
      }
      .navitem-help-text {
        display: none;
      }
      .child-items {
        bottom: 24px;
        label {
          display: inline-block;
        }
      }
    }
    .has-help-text {
        label {
          display: inline-block !important;
          text-align: center;
          width: 100%;
        }
      }
  }

  .navbar-user {
    &.menu-close {
      width: $sidebar-width-non-guest;
      min-width: $sidebar-width-non-guest;
    }
  }

  .navbar-wpr {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .navbar-burger:hover {
    background-color: transparent;
  }

  .has-child-items {
    position: relative;
    padding-left: auto;
    &:hover {
      .child-items {
        display: flex;
        flex-direction: column;
      }
    }
    .navbar-label {
      display: flex;
    }
    .child-items {
      display: none;
      position:absolute;
      left: 24px;
      bottom: 40px;
    }
  }

  .sidebar-expanded {
    .has-child-items {
      .child-items {
          position: absolute;
          left: 0;
          margin: 0;
      }
    }
  }

  .child-items {
    background: #fff;
    border: 1px solid #ddd;
    margin-left: 24px;
    border-radius: 4px;
    padding: 8px;
    box-shadow: 0px -1px 8px rgba(10,10,10,.1);
  }

  .has-help-text {
    flex-direction: column;
    align-items: flex-start;
    // padding: 0 !important;

    &:hover p {
      text-decoration: none !important;
    }

    p {
      font-size: 14px;
    }

    label {
      margin-left: 0;
      font-weight: bold;
      color: $brand-primary;
    }
  }

  .navbar-item {
    padding: 0.75rem;
  }

  @media screen and (max-width: 769px) {
    aside {
      width: 100% !important;
      min-width: 100% !important;
      height: 64px;
      border-bottom: 1px solid #ddd;
      padding-left: 0;
      padding-right: 0;

    }
    .mobile-close {
      flex: none;
      padding-top: 0px;
      .menu-items {
        display: none;
      }
    }
    .menu-item-start {
      flex-grow: 0;
    }
    .mobile-open {
      height: 100vh;
      overflow: auto;
    }
    .navbar-item {
      justify-content: flex-start;
      background-color: transparent;

      &.has-dropdown {
        flex-direction: column;
        align-items: flex-start;
        .navbar-item {
          display: flex;
        }
      }

      label {
        display: inline-block !important;
      }
    }
    .navbar-expender {
      display: none;
    }
  }
  .no-color:hover {
    color: black
  }
  /deep/ .navbar-divider {
    border-top-width: 0.25rem;
    .is-horizontal-divider {
      margin: 0 !important;
    }
  }

  .create-btn{
    background-color: #44C7F0 !important;
    border-radius: 5px !important;
    display: flex !important;
    align-items: center !important;
    color: white !important;
  }
  .create-btn:hover{
    background-color: #44C7F0 !important;
    border-radius: 5px  !important;
    display: flex !important;
    align-items: center !important;
    color: white !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/navbar/sidebar-nav.vue